import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { ReactNode } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import { twMerge } from 'tailwind-merge';

type AccordianProps = {
  open?: boolean;
  header: ReactNode;
  subHeader?: ReactNode;
  children: ReactNode;
  className?: string;
  buttonClassName?: string;
  panelClassName?: string;
};

export const Accordian = ({
  open = true,
  header,
  subHeader,
  children,
  className,
  buttonClassName,
  panelClassName,
}: AccordianProps) => {
  return (
    <Disclosure as="div" className="w-full gap-12" defaultOpen={open}>
      {({ open }) => (
        <>
          <DisclosureButton
            className={twMerge(
              'flex w-full flex-col gap-4 px-3 py-4 md:gap-6 md:p-6',
              buttonClassName,
            )}
          >
            <div
              className={twMerge(
                'flex w-full items-center justify-between',
                className,
              )}
            >
              {header}
              <IoChevronDown
                className={twMerge('size-6', open && 'rotate-180')}
              />
            </div>
            {subHeader}
          </DisclosureButton>
          <DisclosurePanel
            className={twMerge('px-3 pb-4 md:p-6 md:pt-0', panelClassName)}
          >
            {children}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
};

export const BorderedAccordian = (props: AccordianProps) => {
  return (
    <div className="rounded-2xl border border-[#E1E1E1]">
      <Accordian {...props} />
    </div>
  );
};
